module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12QWTWo/tc-custom/9781459268975.jpg?1740888212501",
      "alt": "This image is the cover for the book Maddie's Love-Child, From Here to Paternity"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Maddie's Love-Child, From Here to Paternity\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("FROM HERE TO PATERNITY")]), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("She wanted a babybut not a man!")])]), _c('br'), _c('br'), _vm._v("After Miles met Maddie, she stayed on his mind. In the end he returned to Australia to get Maddie out of his system by bedding her for six months or somarriage would never be a part of his agenda"), _c('br'), _c('br'), _vm._v("Which suited Maddie just fine. She adored men, but had no faith in themand no intention of marrying, either. But she did want a baby! And Miles had all the qualities Maddie wanted in the father of her child: brains, breeding and beauty. Not that she would ever let him know"), _c('br'), _c('br'), _c('b', [_vm._v("FROM HERE TO PATERNITYmen who find their way to fatherhood by fair means, by foul, or even by default!")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Miranda Lee\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0